<template>
    <el-container>
        <fhead></fhead>
        <el-main>
            <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('l.asset.title')}}{{$t('l.hour')}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card class="box-card center" style="margin-top: 16px">
                <div slot="header" class="clearfix">
                    <span>{{$t('l.asset.title1')}}</span>
                    <div style="float: right;margin-top: -10px;">
                        <el-input
                                :placeholder="$t('l.asset.search')"
                                prefix-icon="el-icon-search"
                                v-model="search"
                                @change="test">
                        </el-input>
                    </div>
                </div>
                <el-table class="center"
                          v-loading="Loading"
                          stripe
                          :data="List"
                          style="width: 100%">
                    <el-table-column
                            type="index"
                            :index="indexMethod"
                            label=""
                            width="60">
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.asset.account')"
                            width="260">
                        <template slot-scope="scope">
                            <router-link :to="'/assetaccounts/'+scope.row.asset.account">
                                <el-button type="text"> {{scope.row.asset.account}}</el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.asset.NAME')"
                            width="160">
                        <template slot-scope="scope">
                            <el-button @click="open(scope.row)" type="text">
                                {{scope.row.NAME}}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.asset.INITIAL_QUANTITY')"
                            width="190">
                        <template slot-scope="scope">
                            {{parseFloat(scope.row.INITIAL_QUANTITY).toLocaleString()}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.asset.QUANTITY')"
                            width="190">
                        <template slot-scope="scope">
                            {{parseFloat(scope.row.QUANTITY).toLocaleString()}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="DECIMALS"
                            :label="$t('l.asset.DECIMALS')"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="accountRS"
                            :label="$t('l.asset.accountRS')"
                            width="360">
                        <template slot-scope="scope">
                            <router-link style="position: relative" :to="'/account/'+scope.row.accountRS">
                                <el-button type="text"> {{scope.row.accountRS}}
                                </el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="HEIGHT"
                            :label="$t('l.height')"
                    >
                        <template slot-scope="scope">
                            <router-link style="position: relative" :to="'/block/'+scope.row.HEIGHT">
                                <el-button type="text"> {{scope.row.HEIGHT}}
                                </el-button>
                            </router-link>
                        </template>
                    </el-table-column>

                </el-table>
                <el-pagination
                        style="text-align: center;"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="15"
                        layout="total, prev, pager, next"
                        :total="total">
                </el-pagination>
            </el-card>
        </el-main>
        <el-footer class="footer">
            COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
            <a target="_blank" href="https://hebeblock.com/">HEBEBLOCK</a>
        </el-footer>

    </el-container>
</template>


<script>
    import fhead from './../fhead.vue';

    export default {
        name: 'asset',
        components: {
            fhead
        },
        data() {
            return {
                search: '',
                Loading: false,
                List: [],
                currentPage: 1,
                total: 0
            }
        },
        methods: {
            open(model) {
                console.log(model);
                this.$alert(model.DESCRIPTION, model.NAME, {
                    confirmButtonText: this.$t('l.fhead.prompt.confirm'),
                });
            },
            test() {
                this.currentPage = 1
                this.init()
            },
            indexMethod(index) {
                return (index + 1) + (this.currentPage - 1) * 15;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.accounts();
            },
            init() {
                this.$ajax({
                    method: 'get',
                    url: this.$store.state.walletnxt + 'block/assetCount?search=' + this.search,
                }).then(response => {
                    this.total = parseInt(response[0].COUNT);
                });
                this.accounts()
            },
            accounts() {
                this.Loading = true;
                this.$ajax({
                    method: 'get',
                    url: this.$store.state.walletnxt + 'block/asset?page=' + this.currentPage + '&search=' + this.search,
                }).then(response => {
                    this.Loading = false;
                    this.List = response;
                });
            }
        },
        created: function () {
            this.init();
        }
    }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/asset/index.vue